<template>
    <div style="position: relative; height  : 100%">
        <div>
            <div class="flex justify-between mb-4" style="position: relative;">
                <div class="flex">
                    <vs-icon
                        class="mr-2"
                        style="font-size: 22px; "
                        icon-pack="material-icons"
                        icon="shopping_basket" /> 
                    <h4> SACOLA DE PEDIDOS</h4>
                </div>
                <div>
                    <vs-icon
                        v-if="isSmallerScreen"
                        class="close-btn border border-solid rounded-lg cursor-pointer bg-danger text-white"
                        icon-pack="material-icons"
                        icon="close" 
                        @click="closeSidebar"/> 
                </div>
            </div>

            <vs-divider class="-mt-2" />

            <VuePerfectScrollbar class="pt-4" :settings="scrollSettings" :class="isSmallerScreen ? 'scroll-area-upper-mobile' : 'scroll-area-upper-large-screen'">
                
                <div class="w-full" v-if="productsOrder.length || taxesToBeSend.byPerson">

                    <!-- TAXES -->
                    <a-collapse v-model="activeOpenedTax" class="w-full bg-grey-light" v-if="taxesToBeSend.byPerson">
                         <a-collapse-panel :showArrow="false" class="w-full" >
                             <template v-slot:header v-if="taxesToBeSend.byPerson">
                                <div class="flex justify-between">
                                    <div class="mt-1">
                                        {{ taxesToBeSend.byPerson.persons }}x {{ taxesToBeSend.byPerson.description }} ({{ taxesToBeSend.byPerson.totalByPersonPaid | currency }})
                                    </div>
                                    <div>
                                        <a-button @click.stop="deleteTax()" > <a-icon type="delete" /> </a-button>
                                    </div>
                                </div>
                            </template>

                            <div v-if="taxesToBeSend.byPerson" clas="w-full">
                                <div class="flex justify-between">
                                    <div class="mt-3 font-bold">
                                        Quantidade:
                                    </div>
                                    <div >
                                        <counter :value="taxesToBeSend.byPerson.persons" :min="1" @input="val => changeTaxQuantity(val, 'byPerson')"/>
                                    </div>
                                </div>
                            </div>
                         </a-collapse-panel>
                    </a-collapse>

                    <vs-divider border-style="dashed" v-if="taxesToBeSend.byPerson"> <a-icon type="arrow-down" /> PRODUTOS <a-icon type="arrow-down" /> </vs-divider>

                    <!-- PRODUCTS -->
                    <a-collapse v-model="activeOpenedProduct" class="w-full" >
                        <a-collapse-panel :showArrow="false" class="w-full" v-for="(order) in productsOrder" :key="order.key">
                            <!-- TITLE -->
                            <template v-slot:header>
                                <div class="flex justify-between">
                                    <div class="mt-1">
                                        {{ order.quantity }}x {{ order.product.description }}
                                    </div>
                                    <div>
                                        <!-- <a-icon type="delete" style="font-size: 18px" class="text-danger" @click.stop="removeOrder(order)" /> -->
                                        <a-button @click.stop="removeOrder(order)"> <a-icon type="delete" /> </a-button>
                                    </div>
                                </div>
                            </template>
                            
                            <!-- TITLE -->
                                <div class="flex justify-between mb-2">
                                    <label class="font-bold">Total:</label>
                                    <label> {{ order.value | currency }} </label>
                                </div>
                                <div class="w-full">
                                    <p class="font-bold">Obs:</p>
                                    <vs-textarea :value="order.obs" class="-mt-2" @input="val => changeOrderObs(val, order.key)" />
                                </div>
                                <div class="flex justify-between">
                                    <div class="mt-3 font-bold">
                                        Quantidade:
                                    </div>
                                    <div >
                                        <counter :value="order.quantity" :min="1" @input="val => changeProductQuantity(val, order.key)"/>
                                    </div>
                                </div>
                                <div class="flex mt-4">
                                    <vs-checkbox class="w-full mb-6" size="large" :value="order.print" @input="val => changePrint(val, order.key)"> Imprimir na cozinha </vs-checkbox>
                                </div>
                                
                        </a-collapse-panel>
                    </a-collapse>
                </div>
                <div v-else class="flex justify-center">
                    <p class="text-grey"> Não há produtos na sacola </p>
                </div>
            </VuePerfectScrollbar>
        </div>

        <div class="control-buttons w-full border border-dashed border-grey border-t-2 border-b-0 border-l-0 border-r-0 pt-6" :class="{'pb-4 pl-4 pr-4' : isSmallerScreen}">
            <div class="w-full">
                <vs-button id="sendOrders" class="w-full vs-con-loading__container" @click="confirmOrder" :disabled="!productsOrder.length && !taxesToBeSend.byPerson"> ENVIAR PEDIDOS ({{ totalToPay + (taxesToBeSend.byPerson ? taxesToBeSend.byPerson.totalByPersonPaid : 0) | currency }}) </vs-button>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions, mapMutations } from 'vuex'
    import Counter from '../Counter'
    import VuePerfectScrollbar from 'vue-perfect-scrollbar'

    export default {
        props : {
            tableId : String
        },

        components : {
            Counter,
            VuePerfectScrollbar
        },

        data () {
            return {
                loading : false,
                activeOpenedProduct : '',
                activeOpenedTax : '',
                scrollSettings : {
                    maxScrollbarLength  : 40,
                    wheelSpeed          : 0.2,
                },
            }
        },

        computed : {
            totalToPay () {
                let acumulator = 0
                this.productsOrder.forEach(p => acumulator += p.value)
                return acumulator
            },

            isSmallerScreen() {
                return this.$store.state.windowWidth < 1200
            },

            ...mapState('order', ['productsOrder']),
            ...mapState('taxes', ['taxesToBeSend'])
        },

        methods : {
            closeSidebar () {
                this.$emit('closeSidebar')
            },
            removeOrder (order) {
                const self = this
                this.$confirm({
                    zIndex : 9999999,
                    title: this.$t('confirmYourIntention'),
                    content: 'Deseja realmente remover este pedido',
                    okText : 'Remover',
                    cancelText : 'Não',
                    okType: 'danger',
                    async onOk () {
                        self.removeProductOrder({ productKey : order.key})
                    }
                })
            },
            changeProductQuantity (val, key) {
                console.log("key", key)
                this.setQuantity({ val : val, index :  this.getProductOrderIndex(key) })
            },
            changeOrderObs (val, key) {
                this.setObs({ val : val, index : this.getProductOrderIndex(key) })
            },
            changePrint (val, key) {
                console.log("-->Change print:", val)
                this.setPrint({ val : val, index : this.getProductOrderIndex(key) })
            },
            getProductOrderIndex (key) {
                return this.productsOrder.findIndex(a => a.key == key)
            },
            async confirmOrder () {
                try {
                    this.$vs.loading()
                    console.log(this.taxesToBeSend)
                    await this.createOrder({tableId: this.tableId, taxes : this.taxesToBeSend})
                    this.cleanUp()
                    this.cleanUpTaxes()
                    this.$emit('saved')
                } catch (err) {
                    this.$error({
                        zIndex : 99999999,
                        title: 'Erro ao enviar pedido!',
                        content: `${err.message}`
                    })
                } finally {
                    this.$vs.loading.close()
                }
            },
            changeTaxQuantity(val) {
                this.changeByPersonQuantity(val)
            },
            deleteTax () {
                this.deleteTaxByPerson()
            },
            ...mapActions('order', ['removeProductOrder', 'createOrder']),
            ...mapMutations('order', ['setQuantity', 'setObs', 'setPrint', 'cleanUp']),
            ...mapActions('taxes', ['deleteTaxByPerson']),
            ...mapMutations('taxes', {changeByPersonQuantity : 'changeByPersonQuantity', cleanUpTaxes : 'cleanUp'})
        }
    }
</script>

<style lang="scss" scoped>
    .close-btn {
        position: absolute;
        font-size: 30px;
        right: 0;
        top: -5px;
    }

    .scroll-area-upper-large-screen { 
        height: calc(100vh - 280px)
    }

    .scroll-area-upper-mobile {
        height: calc(100vh - 150px)
    }

    .control-buttons {
        position : absolute;
        bottom: 0;
        left: 0;
    }
</style>